import { render, staticRenderFns } from "./EmailSent.vue?vue&type=template&id=d9d275cc&scoped=true"
import script from "./EmailSent.vue?vue&type=script&lang=js"
export * from "./EmailSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d275cc",
  null
  
)

export default component.exports